import Vue from "vue";
import VueRouter from "vue-router";
import Catalog from "../components/Catalog";

Vue.use(VueRouter);

export default new VueRouter({
  mode: "history",
  routes: [
    { path: "*", component: Catalog, props: true},
  ]
});